import React from 'react';

export const AttendanceTabSkeleton: React.FC = () => {
  return (
    <div className="space-y-6 w-full mb-16">
      {/* Metrics Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 auto-rows-fr">
        {[...Array(4)].map((_, index) => (
          <div
            key={index}
            className="bg-white p-6 rounded-xl border border-[#E4E8EA] animate-pulse"
            style={{ animationDelay: `${index * 0.1}s` }}
          >
            <div className="flex items-center mb-2">
              <div className="w-8 h-8 rounded-full bg-gray-200 mr-3"></div>
              <div className="h-5 w-32 bg-gray-200 rounded"></div>
            </div>
            <div className="h-8 w-16 bg-gray-100 rounded mt-2"></div>
          </div>
        ))}
      </div>

      {/* Calendar Skeleton */}
      <div className="bg-white rounded-2xl p-6 border border-[#E4E8EA]">
        <div className="flex justify-between items-center mb-6">
          <div className="h-6 w-36 bg-gray-200 rounded animate-pulse"></div>
          <div className="flex gap-2">
            <div className="h-8 w-8 bg-gray-200 rounded animate-pulse"></div>
            <div className="h-8 w-8 bg-gray-200 rounded animate-pulse"></div>
          </div>
        </div>

        {/* Month Selection */}
        <div className="flex items-center justify-between mb-4">
          <div className="h-6 w-24 bg-gray-200 rounded animate-pulse"></div>
          <div className="flex gap-2">
            <div className="h-8 w-24 bg-gray-200 rounded animate-pulse"></div>
            <div className="h-8 w-8 bg-gray-200 rounded animate-pulse"></div>
          </div>
        </div>

        {/* Days of Week */}
        <div className="grid grid-cols-7 gap-1 mb-2">
          {[...Array(7)].map((_, i) => (
            <div
              key={i}
              className="h-8 bg-gray-100 rounded text-center animate-pulse"
            ></div>
          ))}
        </div>

        {/* Calendar Grid */}
        <div className="grid grid-cols-7 gap-1">
          {[...Array(35)].map((_, i) => (
            <div
              key={i}
              className="h-14 bg-gray-50 rounded flex items-center justify-center animate-pulse"
              style={{ animationDelay: `${(i % 7) * 0.02}s` }}
            >
              <div className="h-8 w-8 bg-gray-100 rounded-full"></div>
            </div>
          ))}
        </div>
      </div>

      {/* Leave Applications */}
      <div className="bg-white rounded-2xl p-6 border border-[#E4E8EA]">
        <div className="flex justify-between items-center mb-6">
          <div className="h-6 w-48 bg-gray-200 rounded animate-pulse"></div>
        </div>

        <div className="space-y-4">
          {[...Array(2)].map((_, i) => (
            <div
              key={i}
              className="border border-[#E4E8EA] rounded-xl p-4 animate-pulse"
              style={{ animationDelay: `${i * 0.1}s` }}
            >
              <div className="flex justify-between items-start">
                <div className="space-y-2">
                  <div className="h-5 w-48 bg-gray-200 rounded"></div>
                  <div className="h-4 w-32 bg-gray-100 rounded"></div>
                </div>
                <div className="h-6 w-24 bg-gray-200 rounded"></div>
              </div>

              <div className="mt-4 h-4 w-full bg-gray-100 rounded"></div>

              <div className="flex justify-end gap-2 mt-4">
                <div className="h-8 w-20 bg-gray-200 rounded"></div>
                <div className="h-8 w-20 bg-gray-200 rounded"></div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Attendance Logs */}
      <div className="bg-white rounded-2xl p-6 border border-[#E4E8EA]">
        <div className="flex justify-between items-center mb-6">
          <div className="h-6 w-48 bg-gray-200 rounded animate-pulse"></div>
        </div>

        <div className="space-y-6">
          {[...Array(3)].map((_, monthIndex) => (
            <div
              key={monthIndex}
              className="animate-pulse"
              style={{ animationDelay: `${monthIndex * 0.1}s` }}
            >
              <div className="mb-4 h-6 w-24 bg-gray-200 rounded"></div>

              <div className="overflow-x-auto">
                <table className="min-w-full">
                  <thead>
                    <tr className="bg-[#F5F8F9] border-y border-[#E4E8EA]">
                      <th className="p-3">
                        <div className="h-5 w-16 bg-gray-200 rounded"></div>
                      </th>
                      <th className="p-3">
                        <div className="h-5 w-20 bg-gray-200 rounded"></div>
                      </th>
                      <th className="p-3">
                        <div className="h-5 w-24 bg-gray-200 rounded"></div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {[...Array(5)].map((_, rowIndex) => (
                      <tr
                        key={rowIndex}
                        className="border-b border-[#E4E8EA]"
                        style={{ animationDelay: `${rowIndex * 0.05}s` }}
                      >
                        <td className="p-3">
                          <div className="h-5 w-20 bg-gray-100 rounded"></div>
                        </td>
                        <td className="p-3">
                          <div className="h-5 w-24 bg-gray-100 rounded"></div>
                        </td>
                        <td className="p-3">
                          <div className="h-5 w-32 bg-gray-100 rounded"></div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
